<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <div class=" uk-width-1-1@m">
                <h2 class="uk-modal-title">Changer le role d'utilisateur</h2> <br>
            <form @submit.prevent="ChangeRole">
                <fieldset class="uk-fieldset">
                    <div class="uk-width-1-1">
                        <label >N° Téléphone d'utilisateur</label>
                        <input class="uk-input uk-form-width-medium" type="phone" v-model="utilisateur.phone" placeholder="phone" required>
                    </div>
                    <div class="uk-margin">
                        <label >Rôle d'utilisateur</label>
                        <select v-model="utilisateur.role" class="uk-select">
                            <option>client</option>
                            <option>livreur</option>
                            <option>commercial</option>
                            <option>superviseur</option>
                            <option>logisticien</option>
                            <option>administrateur</option>
                        </select>
                    </div>
                </fieldset>
                <div class="d-flex justify-content-center">
                    <button class="btn-round my-1 border-0 px-5 uk-button uk-button-primary" style=" color:#fff;  font-size:1em !important; ">Valider</button>
                </div>
            </form>
            </div>
        </div>
        </div>
</template>
<script>
    import { db, dbstore, auth, fbfunctions } from '../../main';
    import Swal from "sweetalert2";
    export default {
    data(){
        return{
            utilisateur: {
                phone: "",
                role:"",
                load:false
            },
        }
        
    },
    created(){
        this.access = this.$store.getters.user.data.role;
        if(this.access != 5){
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
         Toast.fire({
            icon: "error",
            title: '<span style="color:#B74334">Action non autorisée!</span>',
          });
          this.$router.push({ path: "/admin/livraison/encours"});
        }
    },
    methods: {
    ChangeRole(event) {
      const user = this.utilisateur
      const addPhone = fbfunctions.httpsCallable('otpClient')
                addPhone(user.phone)
            if(user.role === 'client'){
                const addRole = fbfunctions.httpsCallable('addClientRole')
                addRole(user.phone)
            }else if (user.role === 'livreur') {
                const addRole = fbfunctions.httpsCallable('addLivreurRole')
                addRole(user.phone)
            }else if(user.role === 'commercial'){
                const addRole = fbfunctions.httpsCallable('addCommercialRole')
                addRole(user.phone)
            }else if(user.role === 'superviseur'){
                const addRole = fbfunctions.httpsCallable('addSuperviseurRole')
                addRole(user.phone)
            }else if(user.role === 'logisticien'){
                const addRole = fbfunctions.httpsCallable('addLogisticienRole')
                addRole(user.phone)
            }else if(user.role === 'adminstrateur'){
                const addRole = fbfunctions.httpsCallable('addAdminRole')
                addRole(user.phone)
            }

            Swal.fire({
                icon: "success",
                title: "Merci....",
                text: "Role modifié avec succès!",
                allowOutsideClick: false,
              })

            event.target.reset();
            event.preventDefault();
          this.$router.push({ path: "/admin/gestion/utilisateurs" });
        }
    },
}

</script>